import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { calculateAge, cn, formatDate } from 'lib/helpers/utility';

import InfoItem from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/InfoItem';
import { getAddressDisplay } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/lib/helpers';
import Dot from 'components/shared/Dot/Dot';

const PatientInformation = ({ patient, created_at, dueDate, invoiceId }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const itemSize = isMobile ? 'xs' : 'small';

  return (
    <div className="flex min-h-fit px-6 py-3 sm:px-2">
      <div className="flex flex-1 flex-col">
        <InfoItem size={itemSize} value="BILLED TO" color="neutral-500" />
        <InfoItem value={patient?.fullName} />
        <div className="flex flex-row flex-wrap items-center gap-1">
          <InfoItem size={itemSize} value={`#${patient?.id}`} color="neutral-700" />
          {patient?.dob && (
            <>
              <Dot size="xs" color="neutral" />
              <InfoItem size={itemSize} value={formatDate(patient?.dob)} color="neutral-700" />
              <InfoItem
                size={itemSize}
                value={`(${calculateAge({ dateOfBirth: patient?.dob })} years)`}
                color="neutral-700"
              />
            </>
          )}
          <Dot size="xs" color="neutral" />
          <InfoItem size={itemSize} value={patient?.gender} color="neutral-700" />
        </div>
        <InfoItem size={itemSize} value={getAddressDisplay(patient?.userAddress)} />
        <InfoItem size={itemSize} value={patient?.phone} color="neutral-700" />
        <InfoItem size={itemSize} value={patient?.email} color="neutral-700" />
      </div>
      <div className="flex flex-col items-end gap-3">
        <div className={cn('flex flex-col items-end', !invoiceId && 'opacity-0')}>
          <InfoItem size={itemSize} value="INVOICE #" color="neutral-500" />
          <InfoItem size={itemSize} value={invoiceId} color="neutral-700" />
        </div>
        <div className={cn('flex flex-col items-end', !created_at && 'opacity-0')}>
          <InfoItem size={itemSize} value="INVOICE DATE" color="neutral-500" />
          <InfoItem size={itemSize} value={formatDate(created_at)} color="neutral-700" />
        </div>
        <div className={cn('flex flex-col items-end', !dueDate && 'opacity-0')}>
          <InfoItem size={itemSize} value="DUE DATE" color="neutral-500" />
          <InfoItem size={itemSize} value={formatDate(dueDate)} color="neutral-700" />
        </div>
      </div>
    </div>
  );
};
export default PatientInformation;
